/* src/app/education/education.component.css */
/*# sourceMappingURL=education.component.css.map */
